import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useTenant } from '@/contexts/TenantContext';
import type { Lead } from './useLeads';

export interface DashboardStats {
  totalLeads: number;
  newLeadsThisMonth: number;
  pipelineValue: number;
  avgDaysToClose: number;
  leadsChange: number;
  newLeadsChange: number;
  valueChange: number;
  daysChange: number;
  leadsByStage?: { stageId: string; stageName: string; count: number; color: string }[];
}

export function useDashboardStats(projectId?: string) {
  const { currentTenant } = useTenant();
  
  return useQuery({
    queryKey: ['dashboard', 'stats', currentTenant?.id, projectId],
    queryFn: () => api.get<DashboardStats>(`/stats/dashboard${projectId ? `?projectId=${projectId}` : ''}`),
    enabled: !!currentTenant,
  });
}

export function useRecentLeads(limit = 5, projectId?: string) {
  const { currentTenant } = useTenant();
  
  return useQuery({
    queryKey: ['dashboard', 'recentLeads', limit, currentTenant?.id, projectId],
    queryFn: async () => {
      const params = new URLSearchParams({ limit: limit.toString(), page: '1' });
      if (projectId) params.append('projectId', projectId);
      const response = await api.get<{ data: Lead[] }>(`/leads?${params.toString()}`);
      return response.data || [];
    },
    enabled: !!currentTenant,
  });
}
